/* eslint-disable max-lines */
/**
 * List of alternative country names (synonyms) that can be used to match country names from data.
 * For example, 'United States', 'USA' and 'United States of America' should be understood as the same country.
 */
export const ALTERNATIVE_COUNTRY_NAMES_DICTIONARY = [
  {
    officialName: 'Afghanistan',
    allNames: ['af', 'afġānistān', 'afghanistan', 'afg'],
    id: 'AFG',
  },
  {
    id: 'ALA',
    officialName: 'Åland Islands',
    allNames: ['ax', 'ala', 'åland islands', 'aland islands'],
  },
  {
    officialName: 'Albania',
    allNames: ['al', 'shqipëri', 'shqipëria', 'shqipnia', 'albania', 'alb'],
    id: 'ALB',
  },
  {
    officialName: 'Algeria',
    allNames: ['dz', 'dzayer', 'algérie', 'algeria', 'dza'],
    id: 'DZA',
  },
  {
    officialName: 'American Samoa',
    allNames: ['as', 'amerika sāmoa', 'amelika sāmoa', 'sāmoa amelika', 'american samoa', 'asm'],
    id: 'ASM',
  },
  {
    id: 'AND',
    officialName: 'Andorra',
    allNames: ['ad', 'and', 'andorra'],
  },
  {
    officialName: 'Angola',
    allNames: ['ao', 'república de angola', "ʁɛpublika de an'ɡɔla", 'angola', 'ago'],
    id: 'AGO',
  },
  {
    officialName: 'Anguilla',
    allNames: ['ai', 'anguilla', 'aia'],
    id: 'AIA',
  },
  {
    id: 'ATA',
    officialName: 'Antarctica',
    allNames: ['aq', 'ata', 'antarctica'],
  },
  {
    officialName: 'Antigua and Barbuda',
    allNames: ['ag', 'antigua and barbuda', 'atg'],
    id: 'ATG',
  },
  {
    officialName: 'Argentina',
    allNames: ['ar', 'argentine republic', 'república argentina', 'argentina', 'arg'],
    id: 'ARG',
  },
  {
    officialName: 'Armenia',
    allNames: [
      'am',
      'hayastan',
      'republic of armenia',
      'հայաստանի հանրապետություն',
      'armenia',
      'arm',
    ],
    id: 'ARM',
  },
  {
    officialName: 'Aruba',
    allNames: ['aw', 'aruba', 'abw'],
    id: 'ABW',
  },
  {
    officialName: 'Australia',
    allNames: ['au', 'australia', 'aus'],
    id: 'AUS',
  },
  {
    officialName: 'Austria',
    allNames: ['at', 'österreich', 'osterreich', 'oesterreich', 'austria', 'aut'],
    id: 'AUT',
  },
  {
    officialName: 'Azerbaijan',
    allNames: [
      'az',
      'republic of azerbaijan',
      'azərbaycan respublikası',
      'azerbaijan',
      'aze',
      'azerbaijan republic',
    ],
    id: 'AZE',
  },
  {
    officialName: 'Bahrain',
    allNames: ['bh', 'kingdom of bahrain', 'mamlakat al-baḥrayn', 'bahrain', 'bhr'],
    id: 'BHR',
  },
  {
    officialName: 'Bangladesh',
    allNames: [
      'bd',
      "people's republic of bangladesh",
      'gônôprôjatôntri bangladesh',
      'bangladesh',
      'bgd',
    ],
    id: 'BGD',
  },
  {
    officialName: 'Barbados',
    allNames: ['bb', 'barbados', 'brb'],
    id: 'BRB',
  },
  {
    officialName: 'Belarus',
    allNames: [
      'by',
      'bielaruś',
      'republic of belarus',
      'белоруссия',
      'республика беларусь',
      'belorussiya',
      'respublika belarus’',
      'belarus',
      'blr',
    ],
    id: 'BLR',
  },
  {
    officialName: 'Belgium',
    allNames: [
      'be',
      'belgië',
      'belgie',
      'belgien',
      'belgique',
      'kingdom of belgium',
      'koninkrijk belgië',
      'royaume de belgique',
      'königreich belgien',
      'belgium',
      'bel',
    ],
    id: 'BEL',
  },
  {
    officialName: 'Belize',
    allNames: ['bz', 'belize', 'blz'],
    id: 'BLZ',
  },
  {
    officialName: 'Benin',
    allNames: ['bj', 'republic of benin', 'république du bénin', 'benin', 'ben'],
    id: 'BEN',
  },
  {
    officialName: 'Bermuda',
    allNames: ['bm', 'the islands ofbermuda', 'the bermudas', 'somers isles', 'bermuda', 'bmu'],
    id: 'BMU',
  },
  {
    officialName: 'Bhutan',
    allNames: ['bt', 'kingdom of bhutan', 'bhutan', 'btn'],
    id: 'BTN',
  },
  {
    officialName: 'Bolivia',
    allNames: [
      'bo',
      'buliwya',
      'wuliwya',
      'plurinational state of bolivia',
      'estado plurinacional de bolivia',
      'buliwya mamallaqta',
      'wuliwya suyu',
      'tetã volívia',
      'bolivia',
      'bol',
      'plurinational state of',
    ],
    id: 'BOL',
  },
  {
    id: 'BES',
    officialName: 'Bonaire',
    allNames: ['bq', 'bes', 'bonaire', 'sint eustatius and saba', 'caribbean netherlands'],
  },
  {
    officialName: 'Bosnia and Herzegovina',
    allNames: ['ba', 'bosnia-herzegovina', 'босна и херцеговина', 'bosnia and herzegovina', 'bih'],
    id: 'BIH',
  },
  {
    officialName: 'Botswana',
    allNames: ['bw', 'republic of botswana', 'lefatshe la botswana', 'botswana', 'bwa'],
    id: 'BWA',
  },
  {
    id: 'BVT',
    officialName: 'Bouvet Island',
    allNames: ['bv', 'bvt', 'bouvet island'],
  },
  {
    officialName: 'Brazil',
    allNames: [
      'br',
      'brasil',
      'federative republic of brazil',
      'república federativa do brasil',
      'brazil',
      'bra',
    ],
    id: 'BRA',
  },
  {
    officialName: 'British Indian Ocean Territory',
    allNames: ['io', 'british indian ocean territory', 'iot'],
    id: 'IOT',
  },
  {
    officialName: 'Brunei',
    allNames: [
      'bn',
      'nation of brunei',
      'the abode of peace',
      'brunei',
      'brn',
      'brunei darussalam',
    ],
    id: 'BRN',
  },
  {
    officialName: 'Bulgaria',
    allNames: ['bg', 'republic of bulgaria', 'република българия', 'bulgaria', 'bgr'],
    id: 'BGR',
  },
  {
    officialName: 'Burkina Faso',
    allNames: ['bf', 'burkina faso', 'bfa'],
    id: 'BFA',
  },
  {
    officialName: 'Burundi',
    allNames: [
      'bi',
      'republic of burundi',
      "republika y'uburundi",
      'république du burundi',
      'burundi',
      'bdi',
    ],
    id: 'BDI',
  },
  {
    officialName: 'Cambodia',
    allNames: ['kh', 'kingdom of cambodia', 'cambodia', 'khm'],
    id: 'KHM',
  },
  {
    officialName: 'Cameroon',
    allNames: ['cm', 'republic of cameroon', 'république du cameroun', 'cameroon', 'cmr'],
    id: 'CMR',
  },
  {
    officialName: 'Canada',
    allNames: ['ca', 'canada', 'can'],
    id: 'CAN',
  },
  {
    officialName: 'Cape Verde',
    allNames: ['cv', 'republic of cabo verde', 'república de cabo verde', 'cape verde', 'cpv'],
    id: 'CPV',
  },
  {
    officialName: 'Cayman Islands',
    allNames: ['ky', 'cayman islands', 'cym'],
    id: 'CYM',
  },
  {
    officialName: 'Central African Republic',
    allNames: [
      'cf',
      'central african republic',
      'république centrafricaine',
      'central african republic',
      'caf',
    ],
    id: 'CAF',
  },
  {
    officialName: 'Chad',
    allNames: ['td', 'tchad', 'republic of chad', 'république du tchad', 'chad', 'tcd'],
    id: 'TCD',
  },
  {
    officialName: 'Chile',
    allNames: ['cl', 'republic of chile', 'república de chile', 'chile', 'chl'],
    id: 'CHL',
  },
  {
    officialName: 'China',
    allNames: [
      'cn',
      'zhōngguó',
      'zhongguo',
      'zhonghua',
      "people's republic of china",
      '中华人民共和国',
      'zhōnghuá rénmín gònghéguó',
      'china',
      'chn',
    ],
    id: 'CHN',
  },
  {
    officialName: 'Christmas Island',
    allNames: ['cx', 'territory of christmas island', 'christmas island', 'cxr'],
    id: 'CXR',
  },
  {
    officialName: 'Cocos (Keeling) Islands',
    allNames: [
      'cc',
      'territoryof the cocos (keeling) islands',
      'keeling islands',
      'cocos (keeling) islands',
      'cck',
      'cocos islands',
      'cocos [keeling] islands',
    ],
    id: 'CCK',
  },
  {
    officialName: 'Colombia',
    allNames: ['co', 'republic of colombia', 'república de colombia', 'colombia', 'col'],
    id: 'COL',
  },
  {
    officialName: 'Comoros',
    allNames: [
      'km',
      'union of the comoros',
      'union des comores',
      'udzima wa komori',
      'al-ittiḥād al-qumurī',
      'comoros',
      'com',
    ],
    id: 'COM',
  },
  {
    officialName: 'Cook Islands',
    allNames: ['ck', "kūki 'āirani", 'cook islands', 'cok'],
    id: 'COK',
  },
  {
    officialName: 'Costa Rica',
    allNames: ['cr', 'republic of costa rica', 'república de costa rica', 'costa rica', 'cri'],
    id: 'CRI',
  },
  {
    officialName: 'Croatia',
    allNames: [
      'hr',
      'hrvatska',
      'republic of croatia',
      'republika hrvatska',
      'croatia',
      'hrv',
      'croatia, republic of',
      'croatia democratic republic of the',
    ],
    id: 'HRV',
  },
  {
    officialName: 'Cuba',
    allNames: ['cu', 'republic of cuba', 'república de cuba', 'cuba', 'cub'],
    id: 'CUB',
  },
  {
    id: 'CUW',
    officialName: 'Curaçao',
    allNames: ['cw', 'cuw', 'curaçao', 'curacao'],
  },
  {
    officialName: 'Cyprus',
    allNames: [
      'cy',
      'kýpros',
      'kıbrıs',
      'republic of cyprus',
      'κυπριακή δημοκρατία',
      'kıbrıs cumhuriyeti',
      'cyprus',
      'cyp',
    ],
    id: 'CYP',
  },
  {
    officialName: 'Czech Republic',
    allNames: ['cz', 'česká republika', 'česko', 'czech republic', 'cze'],
    id: 'CZE',
  },
  {
    officialName: 'Democratic Republic of the Congo',
    allNames: [
      'cd',
      'dr congo',
      'congo-kinshasa',
      'drc',
      'democratic republic of the congo',
      'cod',
      'congo (kinshasa)',
      'the democratic republic of the congo',
      'congo, the democratic republic of the',
      'congo [drc]',
      'congo, dem. rep.',
    ],
    id: 'COD',
  },
  {
    officialName: 'Denmark',
    allNames: ['dk', 'danmark', 'kingdom of denmark', 'kongeriget danmark', 'denmark', 'dnk'],
    id: 'DNK',
  },
  {
    officialName: 'Djibouti',
    allNames: [
      'dj',
      'jabuuti',
      'gabuuti',
      'republic of djibouti',
      'république de djibouti',
      'gabuutih ummuuno',
      'jamhuuriyadda jabuuti',
      'djibouti',
      'dji',
    ],
    id: 'DJI',
  },
  {
    officialName: 'Dominica',
    allNames: ['dm', 'dominique', 'wai‘tu kubuli', 'commonwealth of dominica', 'dominica', 'dma'],
    id: 'DMA',
  },
  {
    officialName: 'Dominican Republic',
    allNames: ['do', 'dominican republic', 'dom'],
    id: 'DOM',
  },
  {
    officialName: 'East Timor',
    allNames: [
      'tl',
      'east timor',
      'democratic republic of timor-leste',
      'república democrática de timor-leste',
      'repúblika demokrátika timór-leste',
      'east timor',
      'tls',
      'timor-leste',
    ],
    id: 'TLS',
  },
  {
    officialName: 'Ecuador',
    allNames: ['ec', 'republic of ecuador', 'república del ecuador', 'ecuador', 'ecu'],
    id: 'ECU',
  },
  {
    officialName: 'Egypt',
    allNames: ['eg', 'arab republic of egypt', 'egypt', 'egy'],
    id: 'EGY',
  },
  {
    officialName: 'El Salvador',
    allNames: ['sv', 'republic of el salvador', 'república de el salvador', 'el salvador', 'slv'],
    id: 'SLV',
  },
  {
    officialName: 'Equatorial Guinea',
    allNames: [
      'gq',
      'republic of equatorial guinea',
      'república de guinea ecuatorial',
      'république de guinée équatoriale',
      'república da guiné equatorial',
      'equatorial guinea',
      'gnq',
    ],
    id: 'GNQ',
  },
  {
    officialName: 'Eritrea',
    allNames: [
      'er',
      'state of eritrea',
      'ሃገረ ኤርትራ',
      'dawlatiritriyá',
      'ʾertrā',
      'iritriyā',
      'eritrea',
      'eri',
    ],
    id: 'ERI',
  },
  {
    officialName: 'Estonia',
    allNames: ['ee', 'eesti', 'republic of estonia', 'eesti vabariik', 'estonia', 'est'],
    id: 'EST',
  },
  {
    officialName: 'Ethiopia',
    allNames: [
      'et',
      'ʾītyōṗṗyā',
      'federal democratic republic of ethiopia',
      'የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ',
      'ethiopia',
      'eth',
    ],
    id: 'ETH',
  },
  {
    officialName: 'Falkland Islands',
    allNames: [
      'fk',
      'islas malvinas',
      'falkland islands',
      'flk',
      'falkland islands (malvinas)',
      'falkland islands (islas malvinas)',
      'falkland islands [malvinas]',
      'falkland islands [islas malvinas]',
    ],
    id: 'FLK',
  },
  {
    officialName: 'Faroe Islands',
    allNames: ['fo', 'føroyar', 'færøerne', 'faroe islands', 'fro'],
    id: 'FRO',
  },
  {
    officialName: 'Federated States of Micronesia',
    allNames: [
      'fm',
      'federated states of micronesia',
      'federated states of micronesia',
      'fsm',
      'micronesia',
      'federated states of',
    ],
    id: 'FSM',
  },
  {
    officialName: 'Fiji',
    allNames: [
      'fj',
      'viti',
      'republic of fiji',
      'matanitu ko viti',
      'fijī gaṇarājya',
      'fiji',
      'fji',
    ],
    id: 'FJI',
  },
  {
    officialName: 'Finland',
    allNames: [
      'fi',
      'suomi',
      'republic of finland',
      'suomen tasavalta',
      'republiken finland',
      'finland',
      'fin',
    ],
    id: 'FIN',
  },
  {
    officialName: 'France',
    allNames: ['fr', 'french republic', 'république française', 'france', 'fra'],
    id: 'FRA',
  },
  {
    officialName: 'French Guiana',
    allNames: ['gf', 'guiana', 'guyane', 'french guiana', 'guf'],
    id: 'GUF',
  },
  {
    officialName: 'French Polynesia',
    allNames: [
      'pf',
      'polynésie française',
      'french polynesia',
      'pōrīnetia farāni',
      'french polynesia',
      'pyf',
    ],
    id: 'PYF',
  },
  {
    officialName: 'French Southern and Antarctic Lands',
    allNames: ['tf', 'french southern andantarctic lands', 'atf', 'french southern territories'],
    id: 'ATF',
  },
  {
    officialName: 'Gabon',
    allNames: ['ga', 'gabonese republic', 'république gabonaise', 'gabon', 'gab', 'gabon republic'],
    id: 'GAB',
  },
  {
    officialName: 'Georgia',
    allNames: ['ge', 'sakartvelo', 'georgia', 'geo'],
    id: 'GEO',
  },
  {
    officialName: 'Germany',
    allNames: ['de', 'federal republic of germany', 'bundesrepublik deutschland', 'germany', 'deu'],
    id: 'DEU',
  },
  {
    officialName: 'Ghana',
    allNames: ['gh', 'ghana', 'gha'],
    id: 'GHA',
  },
  {
    officialName: 'Gibraltar',
    allNames: ['gi', 'gibraltar', 'gib'],
    id: 'GIB',
  },
  {
    officialName: 'Greece',
    allNames: ['gr', 'elláda', 'hellenic republic', 'ελληνική δημοκρατία', 'greece', 'grc'],
    id: 'GRC',
  },
  {
    officialName: 'Greenland',
    allNames: ['gl', 'grønland', 'greenland', 'grl'],
    id: 'GRL',
  },
  {
    officialName: 'Grenada',
    allNames: ['gd', 'grenada', 'grd'],
    id: 'GRD',
  },
  {
    officialName: 'Guadeloupe',
    allNames: ['gp', 'gwadloup', 'guadeloupe', 'glp'],
    id: 'GLP',
  },
  {
    officialName: 'Guam',
    allNames: ['gu', 'guåhån', 'guam', 'gum'],
    id: 'GUM',
  },
  {
    officialName: 'Guatemala',
    allNames: ['gt', 'guatemala', 'gtm'],
    id: 'GTM',
  },
  {
    officialName: 'Guernsey',
    allNames: ['gg', 'bailiwick of guernsey', 'bailliage de guernesey', 'guernsey', 'ggy'],
    id: 'GGY',
  },
  {
    officialName: 'Guinea',
    allNames: ['gn', 'republic of guinea', 'république de guinée', 'guinea', 'gin'],
    id: 'GIN',
  },
  {
    officialName: 'Guinea-Bissau',
    allNames: [
      'gw',
      'republic of guinea-bissau',
      'república da guiné-bissau',
      'guinea-bissau',
      'gnb',
    ],
    id: 'GNB',
  },
  {
    officialName: 'Guyana',
    allNames: ['gy', 'co-operative republic of guyana', 'guyana', 'guy'],
    id: 'GUY',
  },
  {
    officialName: 'Haiti',
    allNames: ['ht', 'republic of haiti', "république d'haïti", 'repiblik ayiti', 'haiti', 'hti'],
    id: 'HTI',
  },
  {
    officialName: 'Heard Island and McDonald Islands',
    allNames: ['hm', 'heard island and mcdonald islands', 'hmd', 'heard and mcdonald islands'],
    id: 'HMD',
  },
  {
    officialName: 'Honduras',
    allNames: ['hn', 'republic of honduras', 'república de honduras', 'honduras', 'hnd'],
    id: 'HND',
  },
  {
    officialName: 'Hong Kong',
    allNames: ['hk', '香港', 'hongkong', 'hkg', 'hong kong', 'hong kong, china'],
    id: 'HKG',
  },
  {
    officialName: 'Hungary',
    allNames: ['hu', 'hungary', 'hun'],
    id: 'HUN',
  },
  {
    officialName: 'Iceland',
    allNames: ['is', 'island', 'republic of iceland', 'lýðveldið ísland', 'iceland', 'isl'],
    id: 'ISL',
  },
  {
    officialName: 'India',
    allNames: ['in', 'bhārat', 'republic of india', 'bharat ganrajya', 'india', 'ind'],
    id: 'IND',
  },
  {
    officialName: 'Indonesia',
    allNames: ['id', 'republic of indonesia', 'republik indonesia', 'indonesia', 'idn'],
    id: 'IDN',
  },
  {
    officialName: 'Iran',
    allNames: [
      'ir',
      'islamic republic of iran',
      'jomhuri-ye eslāmi-ye irān',
      'iran',
      'irn',
      'islamic republic of',
    ],
    id: 'IRN',
  },
  {
    officialName: 'Iraq',
    allNames: ['iq', 'republic of iraq', 'jumhūriyyat al-‘irāq', 'iraq', 'irq'],
    id: 'IRQ',
  },
  {
    officialName: 'Ireland',
    allNames: ['ie', 'éire', 'republic of ireland', 'poblacht na héireann', 'ireland', 'irl'],
    id: 'IRL',
  },
  {
    officialName: 'Isle of Man',
    allNames: ['im', 'ellan vannin', 'mann', 'mannin', 'isle of man', 'imn'],
    id: 'IMN',
  },
  {
    officialName: 'Israel',
    allNames: ['il', 'state of israel', "medīnat yisrā'el", 'israel', 'isr'],
    id: 'ISR',
  },
  {
    officialName: 'Italy',
    allNames: ['it', 'italian republic', 'repubblica italiana', 'italy', 'ita'],
    id: 'ITA',
  },
  {
    officialName: 'Ivory Coast',
    allNames: [
      'ci',
      'ivory coast',
      "republic of côte d'ivoire",
      "république de côte d'ivoire",
      'ivory coast',
      'civ',
      "côte d'ivoire",
      "cote d'ivoire",
      'cote divoire',
      "cã´te d'ivoire",
      "cote d'lvoire",
    ],
    id: 'CIV',
  },
  {
    officialName: 'Jamaica',
    allNames: ['jm', 'jamaica', 'jam'],
    id: 'JAM',
  },
  {
    officialName: 'Japan',
    allNames: ['jp', 'nippon', 'nihon', 'japan', 'jpn'],
    id: 'JPN',
  },
  {
    officialName: 'Jersey',
    allNames: [
      'je',
      'bailiwick of jersey',
      'bailliage de jersey',
      'bailliage dé jèrri',
      'jersey',
      'jey',
    ],
    id: 'JEY',
  },
  {
    officialName: 'Jordan',
    allNames: [
      'jo',
      'hashemite kingdomof jordan',
      'al-mamlakah al-urdunīyah al-hāshimīyah',
      'jordan',
      'jor',
    ],
    id: 'JOR',
  },
  {
    officialName: 'Kazakhstan',
    allNames: [
      'kz',
      'qazaqstan',
      'казахстан',
      'republic of kazakhstan',
      'қазақстан республикасы',
      'qazaqstan respublïkası',
      'республика казахстан',
      'respublika kazakhstan',
      'kazakhstan',
      'kaz',
    ],
    id: 'KAZ',
  },
  {
    officialName: 'Kenya',
    allNames: ['ke', 'republic of kenya', 'jamhuri ya kenya', 'kenya', 'ken'],
    id: 'KEN',
  },
  {
    officialName: 'Kiribati',
    allNames: ['ki', 'republic of kiribati', 'ribaberiki kiribati', 'kiribati', 'kir'],
    id: 'KIR',
  },
  {
    officialName: 'Kuwait',
    allNames: ['kw', 'state of kuwait', 'dawlat al-kuwait', 'kuwait', 'kwt'],
    id: 'KWT',
  },
  {
    officialName: 'Kyrgyzstan',
    allNames: [
      'kg',
      'киргизия',
      'kyrgyz republic',
      'кыргыз республикасы',
      'kyrgyz respublikasy',
      'kyrgyzstan',
      'kgz',
    ],
    id: 'KGZ',
  },
  {
    officialName: 'Laos',
    allNames: [
      'la',
      'lao',
      "lao people's democratic republic",
      'sathalanalat paxathipatai paxaxon lao',
      'laos',
      'lao',
    ],
    id: 'LAO',
  },
  {
    officialName: 'Latvia',
    allNames: ['lv', 'republic of latvia', 'latvijas republika', 'latvia', 'lva'],
    id: 'LVA',
  },
  {
    officialName: 'Lebanon',
    allNames: ['lb', 'lebanese republic', 'al-jumhūrīyah al-libnānīyah', 'lebanon', 'lbn'],
    id: 'LBN',
  },
  {
    officialName: 'Lesotho',
    allNames: ['ls', 'kingdom of lesotho', 'muso oa lesotho', 'lesotho', 'lso'],
    id: 'LSO',
  },
  {
    officialName: 'Liberia',
    allNames: ['lr', 'republic of liberia', 'liberia', 'lbr'],
    id: 'LBR',
  },
  {
    officialName: 'Libya',
    allNames: ['ly', 'state of libya', 'dawlat libya', 'libya', 'lby'],
    id: 'LBY',
  },
  {
    officialName: 'Liechtenstein',
    allNames: [
      'li',
      'principality of liechtenstein',
      'fürstentum liechtenstein',
      'liechtenstein',
      'lie',
    ],
    id: 'LIE',
  },
  {
    officialName: 'Lithuania',
    allNames: ['lt', 'republic of lithuania', 'lietuvos respublika', 'lithuania', 'ltu'],
    id: 'LTU',
  },
  {
    officialName: 'Luxembourg',
    allNames: [
      'lu',
      'grand duchy of luxembourg',
      'grand-duché de luxembourg',
      'großherzogtum luxemburg',
      'groussherzogtum lëtzebuerg',
      'luxembourg',
      'lux',
    ],
    id: 'LUX',
  },
  {
    officialName: 'Macau',
    allNames: [
      'mo',
      '澳门',
      "macao special administrative region of the people's republic of china",
      '中華人民共和國澳門特別行政區',
      'região administrativa especial de macau da república popular da china',
      'macau',
      'mac',
      'macao',
      'macao, china',
      'macau, china',
    ],
    id: 'MAC',
  },
  {
    officialName: 'Madagascar',
    allNames: [
      'mg',
      'republic of madagascar',
      "repoblikan'i madagasikara",
      'république de madagascar',
      'madagascar',
      'mdg',
    ],
    id: 'MDG',
  },
  {
    officialName: 'Malawi',
    allNames: ['mw', 'republic of malawi', 'malawi', 'mwi'],
    id: 'MWI',
  },
  {
    officialName: 'Malaysia',
    allNames: ['my', 'malaysia', 'mys'],
    id: 'MYS',
  },
  {
    officialName: 'Maldives',
    allNames: [
      'mv',
      'maldive islands',
      'republic of the maldives',
      'dhivehi raajjeyge jumhooriyya',
      'maldives',
      'mdv',
    ],
    id: 'MDV',
  },
  {
    officialName: 'Mali',
    allNames: ['ml', 'republic of mali', 'république du mali', 'mali', 'mli'],
    id: 'MLI',
  },
  {
    officialName: 'Malta',
    allNames: ['mt', 'republic of malta', "repubblika ta' malta", 'malta', 'mlt'],
    id: 'MLT',
  },
  {
    officialName: 'Marshall Islands',
    allNames: [
      'mh',
      'republic of the marshall islands',
      'aolepān aorōkin m̧ajeļ',
      'marshall islands',
      'mhl',
    ],
    id: 'MHL',
  },
  {
    officialName: 'Martinique',
    allNames: ['mq', 'martinique', 'mtq'],
    id: 'MTQ',
  },
  {
    officialName: 'Mauritania',
    allNames: [
      'mr',
      'islamic republic of mauritania',
      'al-jumhūriyyah al-ʾislāmiyyah al-mūrītāniyyah',
      'mauritania',
      'mrt',
    ],
    id: 'MRT',
  },
  {
    officialName: 'Mauritius',
    allNames: ['mu', 'republic of mauritius', 'république de maurice', 'mauritius', 'mus'],
    id: 'MUS',
  },
  {
    officialName: 'Mayotte',
    allNames: ['yt', 'department of mayotte', 'département de mayotte', 'mayotte', 'myt'],
    id: 'MYT',
  },
  {
    officialName: 'Mexico',
    allNames: [
      'mx',
      'mexicanos',
      'united mexican states',
      'estados unidos mexicanos',
      'mexico',
      'mex',
    ],
    id: 'MEX',
  },
  {
    officialName: 'Moldova',
    allNames: ['md', 'republic of moldova', 'republica moldova', 'moldova', 'mda', 'republic of'],
    id: 'MDA',
  },
  {
    officialName: 'Monaco',
    allNames: ['mc', 'principality of monaco', 'principauté de monaco', 'monaco', 'mco'],
    id: 'MCO',
  },
  {
    officialName: 'Mongolia',
    allNames: ['mn', 'mongolia', 'mng'],
    id: 'MNG',
  },
  {
    id: 'MNE',
    officialName: 'Montenegro',
    allNames: ['me', 'mne', 'montenegro'],
  },
  {
    officialName: 'Montserrat',
    allNames: ['ms', 'montserrat', 'msr'],
    id: 'MSR',
  },
  {
    officialName: 'Morocco',
    allNames: [
      'ma',
      'kingdom of morocco',
      'al-mamlakah al-maġribiyah',
      'morocco',
      'mar',
      'morroco',
    ],
    id: 'MAR',
  },
  {
    officialName: 'Mozambique',
    allNames: ['mz', 'republic of mozambique', 'república de moçambique', 'mozambique', 'moz'],
    id: 'MOZ',
  },
  {
    id: 'MMR',
    officialName: 'Myanmar',
    allNames: ['mm', 'mmr', 'myanmar', 'myanmar (burma)', 'myanmar [burma]', 'burma'],
  },
  {
    officialName: 'Namibia',
    allNames: ['na', 'namibië', 'republic of namibia', 'namibia', 'nam'],
    id: 'NAM',
  },
  {
    officialName: 'Nauru',
    allNames: [
      'nr',
      'naoero',
      'pleasant island',
      'republic of nauru',
      'ripublik naoero',
      'nauru',
      'nru',
    ],
    id: 'NRU',
  },
  {
    officialName: 'Nepal',
    allNames: [
      'np',
      'federal democratic republic of nepal',
      'loktāntrik ganatantra nepāl',
      'nepal',
      'npl',
    ],
    id: 'NPL',
  },
  {
    officialName: 'Netherlands',
    allNames: ['nl', 'holland', 'nederland', 'netherlands', 'nld', 'the netherlands'],
    id: 'NLD',
  },
  {
    officialName: 'New Caledonia',
    allNames: ['nc', 'new caledonia', 'ncl'],
    id: 'NCL',
  },
  {
    officialName: 'New Zealand',
    allNames: ['nz', 'aotearoa', 'new zealand', 'nzl'],
    id: 'NZL',
  },
  {
    officialName: 'Nicaragua',
    allNames: ['ni', 'republic of nicaragua', 'república de nicaragua', 'nicaragua', 'nic'],
    id: 'NIC',
  },
  {
    officialName: 'Niger',
    allNames: ['ne', 'nijar', 'republic of niger', 'république du niger', 'niger', 'ner'],
    id: 'NER',
  },
  {
    officialName: 'Nigeria',
    allNames: ['ng', 'nijeriya', 'naíjíríà', 'federal republic of nigeria', 'nigeria', 'nga'],
    id: 'NGA',
  },
  {
    officialName: 'Niue',
    allNames: ['nu', 'niue', 'niu'],
    id: 'NIU',
  },
  {
    officialName: 'Norfolk Island',
    allNames: [
      'nf',
      'territory of norfolk island',
      "teratri of norf'k ailen",
      'norfolk island',
      'nfk',
    ],
    id: 'NFK',
  },
  {
    officialName: 'North Korea',
    allNames: [
      'kp',
      "democratic people's republic of korea",
      '조선민주주의인민공화국',
      'chosŏn minjujuŭi inmin konghwaguk',
      'north korea',
      'prk',
      "korea, democratic people's republic of",
      'korea, north',
    ],
    id: 'PRK',
  },
  {
    officialName: 'Northern Mariana Islands',
    allNames: [
      'mp',
      'commonwealth of the northern mariana islands',
      'sankattan siha na islas mariånas',
      'northern mariana islands',
      'mnp',
    ],
    id: 'MNP',
  },
  {
    officialName: 'Norway',
    allNames: [
      'no',
      'norge',
      'noreg',
      'kingdom of norway',
      'kongeriket norge',
      'kongeriket noreg',
      'norway',
      'nor',
    ],
    id: 'NOR',
  },
  {
    officialName: 'Oman',
    allNames: ['om', 'sultanate of oman', 'salṭanat ʻumān', 'oman', 'omn'],
    id: 'OMN',
  },
  {
    officialName: 'Pakistan',
    allNames: [
      'pk',
      'pākistān',
      'islamic republic of pakistan',
      "islāmī jumhūriya'eh pākistān",
      'pakistan',
      'pak',
    ],
    id: 'PAK',
  },
  {
    officialName: 'Palau',
    allNames: ['pw', 'republic of palau', 'beluuer a belau', 'palau', 'plw'],
    id: 'PLW',
  },
  {
    id: 'PSE',
    officialName: 'Palestinian Authority',
    allNames: ['ps', 'pse', 'palestinian authority', 'palestinian territory'],
  },
  {
    officialName: 'Panama',
    allNames: ['pa', 'republic of panama', 'república de panamá', 'panama', 'pan'],
    id: 'PAN',
  },
  {
    officialName: 'Papua New Guinea',
    allNames: [
      'pg',
      'independent state of papua new guinea',
      'independen stet bilong papua niugini',
      'papua new guinea',
      'png',
    ],
    id: 'PNG',
  },
  {
    officialName: 'Paraguay',
    allNames: [
      'py',
      'republic of paraguay',
      'república del paraguay',
      'tetã paraguái',
      'paraguay',
      'pry',
    ],
    id: 'PRY',
  },
  {
    officialName: 'Peru',
    allNames: ['pe', 'republic of peru', 'república del perú', 'peru', 'per'],
    id: 'PER',
  },
  {
    officialName: 'Philippines',
    allNames: ['ph', 'republic of the philippines', 'repúblika ng pilipinas', 'philippines', 'phl'],
    id: 'PHL',
  },
  {
    officialName: 'Pitcairn Islands',
    allNames: [
      'pn',
      'pitcairn henderson ducie and oeno islands',
      'pitcairn islands',
      'pcn',
      'pitcairn',
    ],
    id: 'PCN',
  },
  {
    officialName: 'Poland',
    allNames: ['pl', 'republic of poland', 'rzeczpospolita polska', 'poland', 'pol'],
    id: 'POL',
  },
  {
    officialName: 'Portugal',
    allNames: [
      'pt',
      'portuguesa',
      'portuguese republic',
      'república portuguesa',
      'portugal',
      'prt',
    ],
    id: 'PRT',
  },
  {
    officialName: 'Puerto Rico',
    allNames: [
      'pr',
      'commonwealth of puerto rico',
      'estado libre asociado de puerto rico',
      'puerto rico',
      'pri',
    ],
    id: 'PRI',
  },
  {
    officialName: 'Qatar',
    allNames: ['qa', 'state of qatar', 'dawlat qaṭar', 'qatar', 'qat'],
    id: 'QAT',
  },
  {
    officialName: 'Republic of Macedonia',
    allNames: [
      'mk',
      'republic of macedonia',
      'република македонија',
      'republic of macedonia',
      'mkd',
      'macedonia',
      'macedonia (fyrom)',
      'macedonia [fyrom]',
      'the former yugoslav republic of',
      'the former yugoslav republic of macedonia',
    ],
    id: 'MKD',
  },
  {
    officialName: 'Republic of the Congo',
    allNames: [
      'cg',
      'congo-brazzaville',
      'republic of the congo',
      'cog',
      'congo (brazzaville)',
      'congo [republic]',
      'congo',
      'congo, rep.',
    ],
    id: 'COG',
  },
  {
    officialName: 'Réunion',
    allNames: ['re', 'reunion', 'réunion', 'reu', 'rã©union'],
    id: 'REU',
  },
  {
    officialName: 'Romania',
    allNames: ['ro', 'rumania', 'roumania', 'românia', 'romania', 'rou'],
    id: 'ROU',
  },
  {
    officialName: 'Russia',
    allNames: [
      'ru',
      'rossiya',
      'russian federation',
      'российская федерация',
      'rossiyskaya federatsiya',
      'russia',
      'rus',
    ],
    id: 'RUS',
  },
  {
    officialName: 'Rwanda',
    allNames: [
      'rw',
      'republic of rwanda',
      "repubulika y'u rwanda",
      'république du rwanda',
      'rwanda',
      'rwa',
    ],
    id: 'RWA',
  },
  {
    id: 'BLM',
    officialName: 'Saint Barthélemy',
    allNames: ['bl', 'blm', 'saint barthélemy', 'saint barthelemy', 'st barthelemy'],
  },
  {
    officialName: 'Saint Helena',
    allNames: ['sh', 'saint helena', 'shn', 'st helena', 'ascension and tristan da cunha'],
    id: 'SHN',
  },
  {
    officialName: 'Saint Kitts and Nevis',
    allNames: [
      'kn',
      'federation of saint christopher and nevis',
      'saint kitts and nevis',
      'kna',
      'st kitts and nevis',
      'saint kitts-nevis',
      'st kitts-nevis',
    ],
    id: 'KNA',
  },
  {
    officialName: 'Saint Lucia',
    allNames: ['lc', 'saint lucia', 'lca', 'st lucia'],
    id: 'LCA',
  },
  {
    officialName: 'Saint Pierre and Miquelon',
    allNames: [
      'pm',
      'collectivité territoriale de saint-pierre-et-miquelon',
      'saint pierre andmiquelon',
      'spm',
      'st pierre and miquelon',
      'saint pierre and miquelon',
      'st. pierre and miquelon',
    ],
    id: 'SPM',
  },
  {
    officialName: 'Saint Vincent and the Grenadines',
    allNames: ['vc', 'saint vincent and the grenadines', 'vct', 'st vincent and the grenadines'],
    id: 'VCT',
  },
  {
    officialName: 'Samoa',
    allNames: [
      'ws',
      'independent state of samoa',
      'malo saʻoloto tutoʻatasi o sāmoa',
      'samoa',
      'wsm',
      'western samoa',
    ],
    id: 'WSM',
  },
  {
    officialName: 'San Marino',
    allNames: ['sm', 'republic of san marino', 'repubblica di san marino', 'san marino', 'smr'],
    id: 'SMR',
  },
  {
    officialName: 'São Tomé and Príncipe',
    allNames: [
      'st',
      'democratic republic of são tomé and príncipe',
      'república democrática de são tomé e príncipe',
      'são tomé and príncipe',
      'stp',
      'sao tome and principe',
      'sã£o tomã© and prã­ncipe',
    ],
    id: 'STP',
  },
  {
    officialName: 'Saudi Arabia',
    allNames: [
      'sa',
      'kingdom of saudi arabia',
      'al-mamlakah al-‘arabiyyah as-su‘ūdiyyah',
      'saudi arabia',
      'sau',
    ],
    id: 'SAU',
  },
  {
    officialName: 'Senegal',
    allNames: ['sn', 'republic of senegal', 'république du sénégal', 'senegal', 'sen'],
    id: 'SEN',
  },
  {
    id: 'SRB',
    officialName: 'Serbia',
    allNames: ['rs', 'srb', 'serbia'],
  },
  {
    officialName: 'Seychelles',
    allNames: [
      'sc',
      'republic of seychelles',
      'repiblik sesel',
      'république des seychelles',
      'seychelles',
      'syc',
    ],
    id: 'SYC',
  },
  {
    officialName: 'Sierra Leone',
    allNames: ['sl', 'republic of sierra leone', 'sierra leone', 'sle'],
    id: 'SLE',
  },
  {
    officialName: 'Singapore',
    allNames: ['sg', 'singapura', 'republik singapura', '新加坡共和国', 'singapore', 'sgp'],
    id: 'SGP',
  },
  {
    officialName: 'Slovakia',
    allNames: [
      'sk',
      'slovak republic',
      'slovenská republika',
      'slovakia',
      'svk',
      'slovakia (slovak republic)',
    ],
    id: 'SVK',
  },
  {
    officialName: 'Slovenia',
    allNames: ['si', 'republic of slovenia', 'republika slovenija', 'slovenia', 'svn'],
    id: 'SVN',
  },
  {
    officialName: 'Solomon Islands',
    allNames: ['sb', 'solomon islands', 'slb'],
    id: 'SLB',
  },
  {
    officialName: 'Somalia',
    allNames: [
      'so',
      'aṣ-ṣūmāl',
      'federal republic of somalia',
      'jamhuuriyadda federaalka soomaaliya',
      'jumhūriyyat aṣ-ṣūmāl al-fiderāliyya',
      'somalia',
      'som',
    ],
    id: 'SOM',
  },
  {
    officialName: 'South Africa',
    allNames: ['za', 'rsa', 'suid-afrika', 'republic of south africa', 'south africa', 'zaf'],
    id: 'ZAF',
  },
  {
    officialName: 'South Georgia',
    allNames: ['gs', 'south georgia and the south sandwich islands', 'south georgia', 'sgs'],
    id: 'SGS',
  },
  {
    officialName: 'South Korea',
    allNames: [
      'kr',
      'republic of korea',
      'south korea',
      'kor',
      'korea,  republic of',
      'korea, south',
    ],
    id: 'KOR',
  },
  {
    officialName: 'South Sudan',
    allNames: ['ss', 'south sudan', 'ssd'],
    id: 'SSD',
  },
  {
    officialName: 'Spain',
    allNames: ['es', 'kingdom of spain', 'reino deespaña', 'spain', 'esp'],
    id: 'ESP',
  },
  {
    officialName: 'Sri Lanka',
    allNames: ['lk', 'ilaṅkai', 'democraticsocialist republic of sri lanka', 'sri lanka', 'lka'],
    id: 'LKA',
  },
  {
    id: 'SXM',
    officialName: 'St Maarten',
    allNames: [
      'sx',
      'sxm',
      'st maarten',
      'sint maarten',
      'sint maarten (dutch part)',
      'saint-martin (pays-bas)',
    ],
  },
  {
    id: 'MAF',
    officialName: 'St Martin (French part)',
    allNames: [
      'mf',
      'maf',
      'st martin (french part)',
      'saint martin (french part)',
      'saint-martin (france)',
    ],
  },
  {
    officialName: 'Sudan',
    allNames: ['sd', 'republic of the sudan', 'jumhūrīyat as-sūdān', 'sudan', 'sdn'],
    id: 'SDN',
  },
  {
    officialName: 'Suriname',
    allNames: [
      'sr',
      'sarnam',
      'sranangron',
      'republic of suriname',
      'republiek suriname',
      'suriname',
      'sur',
    ],
    id: 'SUR',
  },
  {
    officialName: 'Svalbard and Jan Mayen',
    allNames: ['sj', 'svalbard and jan mayen islands', 'svalbard and jan mayen', 'sjm'],
    id: 'SJM',
  },
  {
    officialName: 'Swaziland',
    allNames: [
      'sz',
      'weswatini',
      'swatini',
      'ngwane',
      'kingdom of swaziland',
      'umbuso waseswatini',
      'swaziland',
      'swz',
    ],
    id: 'SWZ',
  },
  {
    officialName: 'Sweden',
    allNames: ['se', 'kingdom of sweden', 'konungariket sverige', 'sweden', 'swe'],
    id: 'SWE',
  },
  {
    officialName: 'Switzerland',
    allNames: [
      'ch',
      'swiss confederation',
      'schweiz',
      'suisse',
      'svizzera',
      'svizra',
      'switzerland',
      'che',
    ],
    id: 'CHE',
  },
  {
    officialName: 'Syria',
    allNames: [
      'sy',
      'syrian arab republic',
      'al-jumhūrīyah al-ʻarabīyah as-sūrīyah',
      'syria',
      'syr',
    ],
    id: 'SYR',
  },
  {
    officialName: 'Taiwan',
    allNames: [
      'tw',
      'táiwān',
      'republic of china',
      '中華民國',
      'zhōnghuá mínguó',
      'taiwan',
      'twn',
      'taiwan, province of china',
    ],
    id: 'TWN',
  },
  {
    officialName: 'Tajikistan',
    allNames: [
      'tj',
      'toçikiston',
      'republic of tajikistan',
      'ҷумҳурии тоҷикистон',
      'çumhuriyi toçikiston',
      'tajikistan',
      'tjk',
    ],
    id: 'TJK',
  },
  {
    officialName: 'Tanzania',
    allNames: [
      'tz',
      'united republic of tanzania',
      'jamhuri ya muungano wa tanzania',
      'tanzania',
      'tza',
      'united republic of',
    ],
    id: 'TZA',
  },
  {
    officialName: 'Thailand',
    allNames: [
      'th',
      'prathet',
      'thai',
      'kingdom of thailand',
      'ราชอาณาจักรไทย',
      'ratcha anachak thai',
      'thailand',
      'tha',
    ],
    id: 'THA',
  },
  {
    officialName: 'The Bahamas',
    allNames: ['bs', 'commonwealth of the bahamas', 'the bahamas', 'bhs', 'bahamas'],
    id: 'BHS',
  },
  {
    officialName: 'The Gambia',
    allNames: ['gm', 'republic of the gambia', 'the gambia', 'gmb', 'gambia'],
    id: 'GMB',
  },
  {
    officialName: 'Togo',
    allNames: ['tg', 'togolese', 'togolese republic', 'république togolaise', 'togo', 'tgo'],
    id: 'TGO',
  },
  {
    officialName: 'Tokelau',
    allNames: ['tk', 'tokelau', 'tkl'],
    id: 'TKL',
  },
  {
    officialName: 'Tonga',
    allNames: ['to', 'tonga', 'ton'],
    id: 'TON',
  },
  {
    officialName: 'Trinidad and Tobago',
    allNames: ['tt', 'republic of trinidad and tobago', 'trinidad and tobago', 'tto'],
    id: 'TTO',
  },
  {
    officialName: 'Tunisia',
    allNames: ['tn', 'republic of tunisia', 'al-jumhūriyyah at-tūnisiyyah', 'tunisia', 'tun'],
    id: 'TUN',
  },
  {
    officialName: 'Turkey',
    allNames: ['tr', 'turkiye', 'republic of turkey', 'türkiye cumhuriyeti', 'turkey', 'tur'],
    id: 'TUR',
  },
  {
    officialName: 'Turkmenistan',
    allNames: ['tm', 'turkmenistan', 'tkm'],
    id: 'TKM',
  },
  {
    id: 'TCA',
    officialName: 'Turks and Caicos Islands',
    allNames: ['tc', 'tca', 'turks and caicos islands'],
  },
  {
    officialName: 'Tuvalu',
    allNames: ['tv', 'tuvalu', 'tuv'],
    id: 'TUV',
  },
  {
    officialName: 'Uganda',
    allNames: ['ug', 'republic of uganda', 'jamhuri ya uganda', 'uganda', 'uga'],
    id: 'UGA',
  },
  {
    officialName: 'Ukraine',
    allNames: ['ua', 'ukrayina', 'ukraine', 'ukr'],
    id: 'UKR',
  },
  {
    officialName: 'United Arab Emirates',
    allNames: ['ae', 'uae', 'united arab emirates', 'are'],
    id: 'ARE',
  },
  {
    officialName: 'United Kingdom',
    allNames: ['gb', 'uk', 'great britain', 'united kingdom', 'gbr', 'britain', 'england'],
    id: 'GBR',
  },
  {
    officialName: 'United States',
    allNames: ['us', 'usa', 'united states of america', 'united states', 'usa'],
    id: 'USA',
  },
  {
    id: 'UMI',
    officialName: 'United States Minor Outlying Islands',
    allNames: ['um', 'umi', 'united states minor outlying islands'],
  },
  {
    officialName: 'Uruguay',
    allNames: [
      'uy',
      'oriental republic of uruguay',
      'república oriental del uruguay',
      'uruguay',
      'ury',
    ],
    id: 'URY',
  },
  {
    officialName: 'Uzbekistan',
    allNames: [
      'uz',
      'republic of uzbekistan',
      'o‘zbekiston respublikasi',
      'ўзбекистон республикаси',
      'uzbekistan',
      'uzb',
    ],
    id: 'UZB',
  },
  {
    officialName: 'Vanuatu',
    allNames: [
      'vu',
      'republic of vanuatu',
      'ripablik blong vanuatu',
      'république de vanuatu',
      'vanuatu',
      'vut',
    ],
    id: 'VUT',
  },
  {
    id: 'VAT',
    officialName: 'Vatican',
    allNames: [
      'va',
      'vat',
      'vatican',
      'vatican city',
      'vatican city state',
      'holy see (vatican city state)',
      'holy see [vatican city state]',
    ],
  },
  {
    officialName: 'Venezuela',
    allNames: [
      've',
      'bolivarian republic of venezuela',
      'república bolivariana de venezuela',
      'venezuela',
      'ven',
      'bolivarian republic of',
    ],
    id: 'VEN',
  },
  {
    officialName: 'Vietnam',
    allNames: [
      'vn',
      'socialist republic of vietnam',
      'cộng hòa xã hội chủ nghĩa việt nam',
      'vietnam',
      'vnm',
      'viet nam',
    ],
    id: 'VNM',
  },
  {
    id: 'VGB',
    officialName: 'Virgin Islands',
    allNames: [
      'vg',
      'vgb',
      'virgin islands',
      'british',
      'british virgin islands',
      'virgin islands (british)',
    ],
  },
  {
    id: 'VIR',
    officialName: 'Virgin Islands',
    allNames: [
      'vi',
      'vir',
      'virgin islands',
      'u.s.',
      'us virgin islands',
      'u.s. virgin islands',
      'virgin islands (u.s.)',
    ],
  },
  {
    officialName: 'Wallis and Futuna',
    allNames: [
      'wf',
      'territory of the wallis and futuna islands',
      'territoire des îles wallis et futuna',
      'wallis and futuna',
      'wlf',
      'wallis and futuna islands',
    ],
    id: 'WLF',
  },
  {
    officialName: 'Western Sahara',
    allNames: ['eh', 'taneẓroft tutrimt', 'western sahara', 'esh'],
    id: 'ESH',
  },
  {
    officialName: 'Yemen',
    allNames: ['ye', 'yemeni republic', 'al-jumhūriyyah al-yamaniyyah', 'yemen', 'yem'],
    id: 'YEM',
  },
  {
    officialName: 'Zambia',
    allNames: ['zm', 'republic of zambia', 'zambia', 'zmb'],
    id: 'ZMB',
  },
  {
    officialName: 'Zimbabwe',
    allNames: ['zw', 'republic of zimbabwe', 'zimbabwe', 'zwe'],
    id: 'ZWE',
  },
];
